import React from "react";
import NftPopup from "../../Pages/NftPopup";

const MyNft = ({
  title,
  MyNft,
  pass,
  descHeading,
  list,
  price,
  heading,
  buyNow,
  subheading,
  Chart,
  setIsOpen,
  toggleTrue,
  toggleFalse,
  modalIsOpen,
}) => {
  return (
    <>
      <section className="nft-journer">
        <div className="container-1280">
          <div className="row nft-head">
            <div className="col-lg-4">
              <div className="toggle-buttons" style={{ cursor: "pointer" }}>
                <p onClick={() => toggleTrue()}>{title}</p>
                <p onClick={() => toggleFalse()}>{MyNft}</p>
              </div>
            </div>
            <div className="col-lg-8">
              <p>{heading}</p>
            </div>
          </div>
          <div className="row game-detail">
            <div className="col-lg-4 game-pass">
              <img
                src={require("../../Assets/img/game-pass.gif")}
                alt="game-pass"
              />
            </div>
            <div className="col-lg-7">
              <h2>{subheading}</h2>
              <div className="inner-content-nft">
                <div className="col-lg-8">
                  <h3>{pass}</h3>
                  <p>{descHeading}</p>
                  <ul>
                    <li>{list}</li>
                    <li>{list}</li>
                    <li>{list}</li>
                    <li>{list}</li>
                  </ul>
                  <Chart />
                </div>

                <div className="col-lg-4">
                  <div className="price">
                    <p>Price:</p>
                    <img
                      src={require("../../Assets/img/poly-vec.png")}
                      alt="poly-vec"
                    />
                    <h4>{price}</h4>
                  </div>
                  <div className="but-btn">
                    <button
                      onClick={() => {
                        setIsOpen(!modalIsOpen);
                      }}
                    >
                      {buyNow}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <NftPopup show={modalIsOpen} setShow={setIsOpen} />
    </>
  );
};

export default MyNft;
